import PaymentMethodsService from '@/services/paymentMethods';

export default {
	namespaced: true,
	state: {
	},

	getters: {
    
	},

	actions: {
		async getPaymentMethods({commit, state, getters, dispatch}){
			try{
				const response = await PaymentMethodsService.getPaymentMethods();
				return response
			}catch(e){
				console.log(e)
			}
    },	
    async getListPaymentMethods({commit, state, getters, dispatch}) {
      try{
				const response = await PaymentMethodsService.getListPaymentMethods("LIST_PAYMENT_METHODS");
				return response
			}catch(e){
				console.log(e)
			}
    },	
		async createPaymentMethods({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await PaymentMethodsService.createPaymentMethods({
					...payload
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		async filterPaymentMethod({ commit, state, getters, dispatch }, payload) {
			let response;
			try {
				response = await PaymentMethodsService.filterPaymentMethod({
					...payload
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		
		async updatePaymentMethods({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await PaymentMethodsService.updatePaymentMethods(payload.id, {
					...payload
				})
			} catch (e) {
				console.log(e);
			}
			return response;
		},
		async deletePaymentMethods({ commit, state, getters, dispatch }, id) {
			let response;
			try {
				response = await PaymentMethodsService.deletePaymentMethods(id);
			} catch (e) {
				console.log(e);
			}
			return response
		}
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
